module.exports = __webpack_public_path__ + "static/2-2de89b79dac7ebebceb5b461f3ab3687.jpg";